import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  // Firebase web configuration identifies this public client application; it
  // is not a secret. Environment values still take precedence for each build.
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBotuZAU4NHfNhaij1282FKMlOdUdsOXy0',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'lifetimememories-ab1c1.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'lifetimememories-ab1c1',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'lifetimememories-ab1c1.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '467544730755',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:467544730755:web:6dd1c440ceb0d3049e3fb6',
};

export const firebaseIsConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);
const app = firebaseIsConfigured ? initializeApp(firebaseConfig) : null;
export const db = app ? getFirestore(app) : null;
export const auth = app ? getAuth(app) : null;
